import MContainer from '@mui/joy/Container';

export const Container: typeof MContainer = MContainer;
// export { ContainerProps, containerClasses };
export * from '@mui/joy/Container';
